export default __webpack_public_path__ + "static/378-9732e5c72957ba81dd453b1af5eb80d5.gif";